export default __webpack_public_path__ + "static/media/success.96243824.svg";